import React, { Component } from "react";
import { connect } from "react-redux";
import { createHashHistory } from "history";
import PropTypes from "prop-types";
import {FormGroup,InputGroup,FormControl,Button,Alert,ButtonGroup,MenuItem,DropdownButton,Modal,ControlLabel,
} from "react-bootstrap";
import Pagination from "react-js-pagination";

import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import { Notification } from "../../components/notifications";
import {
  getAllInvoicesList,
  deleteInvoices
} from "../../redux/actions/invoicesActions";
import isEmpty from "lodash.isempty";
import moment from "moment";
import "../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import loader from "../../style/loader/loader.scss";
import ReactHtmlParser from "react-html-parser";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
  import { CSVLink } from "react-csv";
const history = createHashHistory();
let  csvData = [];
class InvoiceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "INVOICE REPORT"],
      links: ["home","invoicereport"],
      search: "",
      limit: 10,
      show: false,
      isLoading: false,
      invoiceNumber: "fa fa-sort-down",
      direction: "",
      orderBy: "",
       csvData: "",
       startDateRange : "",
       status : "all",
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
     this.handleSubmit = this.handleSubmit.bind(this);
         this.handleStatus = this.handleStatus.bind(this);
  }
  
  handleDismiss() {
    this.setState({ show: false });
  }

  handleExport = data => {
   csvData = [
      [
      "Invoice Number",
      "Company Name",
      "Days Till Overdue",
      "Status",
      "Invoice From",
      "Invoice Created Date",
      "Invoice Amount",
      ]
    ];
    {data &&
      data.map((invoices, index) =>
        
          csvData.push([
            invoices.invoiceNumber,
            invoices.companyName,
           (invoices.daysTillOverdue) ? moment(invoices.daysTillOverdue).format("MM-DD-YYYY") : "",
            invoices.status,
            invoices.invoiceFrom,
            (invoices.invoice_created_date) ? moment(invoices.invoice_created_date).format("MM-DD-YYYY") : "",
            invoices.invoiceAmount,
            
          ])
          )
      
    }

    this.setState({ csvData: csvData });
  };
 

  handleShow() {
    this.setState({ show: true });
  }

   handleStatus(e) {

    this.setState({ status: e.target.value });
    
  }

    handleSubmit(e) {
          e.preventDefault();
           let dateRange = this.state.startDateRange;
   
      if(this.state.startDateRange !== "") {

    this.setState({
      currentPage: 1
    });

      this.props.getAllInvoicesList({ page: 1, limit: this.state.limit,startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
      endDate: moment(dateRange[1]).format('YYYY-MM-DD'),status:this.state.status});
    
    }
    else
    {     
    this.setState({
      currentPage: 1
    });

       this.props.getAllInvoicesList({ page: 1, limit: this.state.limit,status:this.state.status});
    }
  
  }


  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = e.target.value.length > 0 ? e.target.value : "";

    const postData = {
      page: 1,
      limit: 10,
      search: searchstring
    };
    if (searchstring.length > 0) {
       if(this.state.startDateRange !== "")

      {   
        let dateRange = this.state.startDateRange;
         this.props.getAllInvoicesList({
      page: 1,
      search: searchstring,
      limit: this.state.limit,
      startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
      endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
      status:this.state.status
      });

      }
      else
      {
      this.props.getAllInvoicesList({
        page: 1,
        search: searchstring,
        limit: this.state.limit,
         status:this.state.status
      });
    }
      //this.props.getAllInvoicesList(postData);
    }
    else
{ 
       if(this.state.startDateRange !== "")

      {  let dateRange = this.state.startDateRange;
      this.props.getAllInvoicesList({ page: this.state.currentPage, limit: this.state.limit,startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
      endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
      status:this.state.status,search: searchstring });

    }
    else
    {
       this.props.getAllInvoicesList({
        page: this.state.currentPage,
        search: searchstring,
        limit: this.state.limit,
         status:this.state.status
      });

    }
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}Icon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "fa fa-sort-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getAllInvoicesList({
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit
    });
  };

  componentWillMount() {
    if (this.props.invoicesResponse && this.props.invoicesResponse.message) {
      this.setState({
        alertMessage: this.props.invoicesResponse.message,
        msgType: "success",
        show: true
      });
    }
    if (this.props.invoicesUpdate && this.props.invoicesUpdate.message) {
      this.setState({
        alertMessage: this.props.invoicesUpdate.message,
        msgType: "success",
        show: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.fetchingInvoices !== nextProps.fetchingInvoices) {
      this.setState({ isLoading: nextProps.fetchingInvoices });
    }
    if (
      this.props.invoicesAllList !== nextProps.invoicesAllList &&
      !isEmpty(nextProps.invoicesAllList)
    ) {
      const setPageCount =
      nextProps.invoicesAllList.total / nextProps.invoicesAllList.per_page;
      this.setState({ invoices: nextProps.invoicesAllList.data });
      this.setState({ totalRecords: nextProps.invoicesAllList.total });
      this.setState({ perPage: nextProps.invoicesAllList.per_page });
      this.setState({ pageCount: setPageCount });
      this.handleExport(nextProps.invoicesData);
    }
    if (
      this.props.deletedInvoices !== nextProps.deletedInvoices &&
      !isEmpty(nextProps.deletedInvoices)
    ) {
      if (nextProps.deletedInvoices.message) {
        this.setState({
          alertMessage: nextProps.deletedInvoices.message,
          msgType: "success",
          show: true
        });
        this.props.getAllInvoicesList({
          page: this.state.currentPage,
          limit: this.state.limit
        });
      }
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
  }
  componentDidMount() {
           this.handlePageChange(1);
            }
  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  handlePageChange = page => {
  
    this.setState({
      currentPage: page
    });

    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.getAllInvoicesList({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
      
      });
    } else if (this.state.searchString !== "") {
      if(this.state.startDateRange !== "")

      {   
        let dateRange = this.state.startDateRange;
         this.props.getAllInvoicesList({
      page: page,
      search: this.state.search,
      limit: this.state.limit,
      startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
      endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
      status:this.state.status
      });

      }
      else
      {
      this.props.getAllInvoicesList({
        page: page,
        search: this.state.search,
        limit: this.state.limit,
         status:this.state.status
      });
    }
    } 
    

    else {
      this.props.getAllInvoicesList({ page: page, limit: this.state.limit });
    }
  };

  confirmDelete = invoicesID => {

    this.props.deleteInvoices(invoicesID);
  };

    onChangeStartDateRange = date => this.setState({ startDateRange: date });



  handleDelete(invoicesID) {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(invoicesID);
          this.handleShow();
        })
      ]
    });
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    const Header = [
      "Invoice Number",
      "Company Name",
      "Days Till Overdue",
      "Status",
      "Invoice From",
      "Invoice Created Date",
      "Invoice Amount",
      "Action"
    ];
    let invoicesRow;
    let invoicesdata = this.state.invoices ? this.state.invoices : [];
    if (invoicesdata) {
      invoicesRow = invoicesdata.map((invoices, index) => (
        <tr key={invoices.invoicesID}>
          <td>0000{invoices.invoiceNumber}</td>
          <td>{invoices.companyName}</td>
          <td>{(invoices.daysTillOverdue) ? moment(invoices.daysTillOverdue).format("MM-DD-YYYY") : ""}</td>          
          <td>{invoices.status}</td>
          <td>{invoices.invoiceFrom}</td>
          <td>{(invoices.invoice_created_date) ? moment(invoices.invoice_created_date).format("MM-DD-YYYY") : ""}</td>
          <td>{invoices.invoiceAmount}</td>      
          <td>
            <Button
              bsStyle="info"
              onClick={() => history.push(`/InvoicesDetails/${invoices.invoicesID}`)}
            >
              {" "}
              View{" "}
            </Button>
          </td>
        </tr>
      ));
    }

    return (
      <div className="col-lg-12 invoices-list">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Invoice Report</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            {this.state.isLoading ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="clearfix" />
            <div className="row m-t-15">
             <form onSubmit={this.handleSubmit}>
             <div className="col-lg-3">
           <DateRangePicker
             onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                 
                      />
 </div>
                         <div className="col-lg-3">
                    <select
                    name="connectedOption"
                    className="form-control"
                    onChange={this.handleStatus}
                  >
                        <option value="all">ALL</option>
                    <option value="paid">Paid</option>
                    <option value="unpaid">UnPaid</option>
                  </select>
                                                                            
                      
                        </div>
                         <div className="col-lg-3">
                        <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                   
                  >
                    Submit
                  </Button>
                  </div>
                  </form>
              <div className="col-lg-3 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <i className="fa fa-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>   
            <div className="col-lg-12">
            <span className="pull-right">
                {this.state.csvData ? (
                  <CSVLink
                    data={this.state.csvData}
                    filename={"invoice-report.csv"}
                    className="btn btn-danger"
                  >
                    Export CSV
                  </CSVLink>
                ) : null}
              </span>
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th> Invoice Number </th>
                    <th> Company Name </th>
                    <th> Days Till Overdue </th>                    
                    <th> Status </th>
                    <th> Invoice From </th>
                    <th> Invoice Created Date </th>
                    <th> Invoice Amount </th>
                    <th> Actions </th>
                  </tr>
                </thead>
                <tbody>{invoicesRow}</tbody>
              </table>

              <div className="text-center">
              <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={perPage}
                  totalItemsCount={totalRecords}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

InvoiceReport.propTypes = {
  getAllInvoicesList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  invoicesAllList: state.invoicesReducers.invoicesAllList,
  invoicesData: state.invoicesReducers.invoicesData,
  error: state.invoicesReducers.error,
  deletedInvoices: state.invoicesReducers.deletedInvoices,
  invoicesResponse: state.invoicesReducers.invoicesResponse,
  invoicesUpdate: state.invoicesReducers.invoicesUpdate,
  fetchingInvoices: state.invoicesReducers.fetchingInvoices
});

export default connect(mapStateToProps, { getAllInvoicesList, deleteInvoices })(
  InvoiceReport
);



// WEBPACK FOOTER //
// ./src/app/views/invoices/InvoiceReport.js